import { Phone, ShieldCheck, Send, HeartHandshake } from "lucide-react";
import SponsorSectionTwo from "../SponsorePageTwo";

const FooterTwo = () => {
  return (
    <footer className="relative overflow-hidden bg-neutral-950 text-white max-sm:pb-20">
      {/* Background Blur */}
      <div className="absolute left-0 top-0 h-72 w-72 rounded-full bg-lime-500/10 blur-[120px]" />
      <div className="absolute right-0 bottom-0 h-72 w-72 rounded-full bg-red-500/10 blur-[120px]" />

      <div className="relative mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr]">
          {/* Left */}
          <div>
            <div className="flex items-center gap-5">
              <img src="/images/logo-kopdes-2.png" alt="" className="h-24" />

              {/* <div className="h-14 w-px bg-white/20" />

              <img src="/images/logo-rumah-aspirasi.png" alt="" className="h-16" /> */}
            </div>

            <h3 className="mt-8 text-2xl font-bold">Rumah Aspirasi Kopdes Merah Putih</h3>

            <p className="mt-5 max-w-3xl leading-8 text-gray-300">
              Rumah Aspirasi Kopdes Merah Putih ini dikelola oleh <span className="font-semibold text-white">Yayasan Suaraku Swara Semesta</span>, sebuah organisasi nirlaba yang tidak terafiliasi dengan penyelenggara Kopdes maupun
              pemerintah.
            </p>
          </div>

          {/* Right */}
          <div className="space-y-5">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur">
              <div className="flex items-start gap-4">
                <div className="rounded-xl bg-lime-500/15 p-3">
                  <Send className="text-lime-400" size={22} />
                </div>

                <div>
                  <h4 className="font-semibold">Seluruh Aspirasi</h4>

                  <p className="mt-2 text-sm leading-7 text-gray-300">Seluruh data yang diterima akan dikirimkan langsung ke kementerian terkait untuk ditindaklanjuti.</p>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur">
              <div className="flex items-start gap-4">
                <div className="rounded-xl bg-red-500/15 p-3">
                  <HeartHandshake className="text-red-400" size={22} />
                </div>

                <div>
                  <h4 className="font-semibold">PIC Program</h4>

                  <p className="mt-2 text-gray-300">Yudi C Prawira</p>

                  <div className="mt-3 flex items-center gap-2">
                    <Phone size={17} className="text-lime-400" />

                    <a href="https://wa.me/6281384654484" target="_blank" rel="noopener noreferrer" className="font-medium text-lime-400 hover:underline">
                      0813-8465-4484 (WA Only)
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <SponsorSectionTwo /> */}

        {/* Divider */}

        <div className="my-10 h-px bg-white/10" />

        {/* Bottom */}

        <div className="flex flex-col items-center justify-between gap-4 text-center text-sm text-gray-400 md:flex-row">
          <p>© {new Date().getFullYear()} Rumah Aspirasi Kopdes Merah Putih. Seluruh Hak Cipta Dilindungi.</p>

          <div className="flex items-center gap-2">
            <ShieldCheck size={16} className="text-lime-400" />

            <span>Powered by Yayasan Suaraku Swara Semesta</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
